import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAnalyticsAccountSettingsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAnalyticsAccountSettingsInput;
}>;

export type UpdateAnalyticsAccountSettingsMutationResult = { __typename?: 'Mutation' } & {
  updateAnalyticsAccountSettings?: GraphQLTypes.Maybe<
    { __typename?: 'AnalyticsAccountSettingsPayload' } & Pick<
      GraphQLTypes.AnalyticsAccountSettingsPayload,
      'accountId' | 'analyticsEnabled' | 'analyticsSharedUserEnabled'
    > & { errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>> }
  >;
};

export const UpdateAnalyticsAccountSettingsDocument = gql`
  mutation updateAnalyticsAccountSettings($input: UpdateAnalyticsAccountSettingsInput!) {
    updateAnalyticsAccountSettings(input: $input) {
      accountId
      analyticsEnabled
      analyticsSharedUserEnabled
      errors {
        message
        path
      }
    }
  }
`;
